module.exports = __webpack_public_path__ + "img/KGH.2604823b.jpg";